var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoutGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FAF56C37-A3F6-46BA-821E-5B34CC36CB72_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Navigation",
    transform: "translate(-1234.000000, -244.000000)",
    stroke: "#C1C1C1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(1218.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Logout_Gray-16px",
    transform: "translate(17.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.115,3.09787234 C13.58,4.76595745 14.98,8.85106383 13.265,12.2212766 C11.55,15.5914894 7.35,16.9531915 3.885,15.2851064 C0.42000105,13.6170213 -0.98,9.53191489 0.735,6.16170213 C1.4,4.83404255 2.52,3.74468085 3.885,3.09787234",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0 L7,6.80851064",
    id: "Stroke-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoutGray16Px);
export default __webpack_public_path__ + "static/media/Icon_Logout_Gray-16px.7749af97e78bc10fd91c0bf0dda39d58.svg";
export { ForwardRef as ReactComponent };